/**
 * Shared between the (server-rendered) summary panel and the (client) hero pin.
 *
 * Kept out of `product-hero-scroll-pin.tsx` on purpose: every export of a
 * `"use client"` module reaches a server component as a client reference, not
 * as its actual value, so the attribute would never make it into the markup.
 */
export const PRODUCT_SUMMARY_SCROLL_ATTRIBUTE = "data-product-summary-scroll";

/** Spread onto the summary panel's scroll area so the pin can find it. */
export const productSummaryScrollAttributes = {
  [PRODUCT_SUMMARY_SCROLL_ATTRIBUTE]: "true",
} as const;
